var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Card, CardContent, Typography, Box } from '@mui/material';
import { AppIcon, ICON_SIZES } from '../designSystem/icons/AppIcon';
var STICKER_DIAMETER = 72;
export function ActionStickerCard(_a) {
    var title = _a.title, description = _a.description, stickerUrl = _a.stickerUrl, onClick = _a.onClick, _b = _a.showArrow, showArrow = _b === void 0 ? true : _b;
    return (_jsx(Card, { elevation: 0, sx: containerSx, onClick: onClick, children: _jsxs(Box, { sx: cardActionAreaSx, children: [_jsx(Box, { sx: stickerSx, component: "img", src: stickerUrl, alt: "Sticker" }), _jsxs(CardContent, { sx: cardTextSx, children: [_jsxs(Box, { sx: titleIconContainerSx, children: [_jsx(Typography, { variant: "text-md-semibold", sx: titleSx(!!description), children: title }), showArrow && (_jsx(Box, { sx: iconContainerSxSmallScreen, children: _jsx(AppIcon, { iconName: "ArrowCircleUpRight", color: "Colors/Base/Black", diameter: "24px", strokeWidth: "thin" }) }))] }), description && (_jsx(Typography, { variant: "text-sm-regular", sx: descriptionSx, children: description }))] })] }) }));
}
var containerSx = function (_a) {
    var backrs = _a.backrs;
    return ({
        cursor: 'pointer',
        userSelect: 'none',
        border: "1px solid ".concat(backrs.colors['Colors/Foreground/fg-primary']),
        borderRadius: backrs.radius['radius-xl'],
        px: backrs.spacing['spacing-xl'],
        py: backrs.spacing['spacing-2xl'],
        maxWidth: { xs: '100%', sm: '343px' },
        minHeight: '114px',
        height: '100%',
        transition: 'all 0.3s ease-in-out',
        '&:hover': {
            boxShadow: backrs.shadows['shadow-xl'],
            transform: 'translate(-2px, -2px)',
        },
        '&:active': {
            outline: 'none',
            transform: 'translate(0px, 0px)',
            boxShadow: 'none',
            transition: 'all 0s',
        },
    });
};
var cardTextSx = function (_a) {
    var backrs = _a.backrs;
    return ({
        display: 'flex',
        flexDirection: 'column',
        p: backrs.spacing['spacing-none'],
        gap: backrs.spacing['spacing-none'],
        marginLeft: backrs.spacing['spacing-sm'],
        alignSelf: 'flex-start',
        flexGrow: {
            xs: 1,
            sm: 'unset',
        },
        paddingBottom: "".concat(backrs.spacing['spacing-none'], " !important"),
    });
};
var cardActionAreaSx = function (_a) {
    var backrs = _a.backrs;
    return ({
        display: 'flex',
        flexDirection: {
            xs: 'row',
            sm: 'row',
        },
        alignItems: {
            xs: 'flex-start',
            sm: 'center',
        },
        gap: { xs: backrs.spacing['spacing-sm'] },
        textDecoration: 'none',
    });
};
var stickerSx = {
    display: 'flex',
    alignSelf: 'flex-start',
    width: {
        xs: STICKER_DIAMETER * 0.75,
        sm: STICKER_DIAMETER,
    },
    height: {
        xs: STICKER_DIAMETER * 0.75,
        sm: STICKER_DIAMETER,
    },
    minWidth: {
        xs: STICKER_DIAMETER * 0.75,
        sm: STICKER_DIAMETER,
    },
    minHeight: {
        xs: STICKER_DIAMETER * 0.75,
        sm: STICKER_DIAMETER,
    },
    overflow: 'hidden',
    '& img': {
        maxWidth: '500%',
        maxHeight: '100%',
        objectFit: 'contain',
    },
};
var iconContainerSxSmallScreen = {
    cursor: 'pointer',
    height: ICON_SIZES['24px'],
};
var titleIconContainerSx = {
    display: 'flex',
    flexDirection: 'row',
    width: { xs: '100%', sm: 'unset' },
    justifyContent: 'space-between',
};
var titleSx = function (hasDescription) {
    return function (_a) {
        var backrs = _a.backrs;
        return (__assign(__assign({ color: backrs.colors['Colors/Text/text-primary'], alignSelf: {
                xs: 'flex-end',
                sm: 'unset',
            } }, (!hasDescription && {
            marginTop: backrs.spacing['spacing-xl'],
        })), { lineHeight: '1.25rem' }));
    };
};
var descriptionSx = function (_a) {
    var backrs = _a.backrs;
    return ({
        color: backrs.colors['Colors/Text/text-primary'],
        pr: backrs.spacing['spacing-xl'],
    });
};
